import React from 'react';
import { Home, Check, ArrowDown, ArrowRight } from 'lucide-react';
import '../styles/Preparation.css';

const Preparation = ({ onNext }) => {
  return (
    <div className="preparation-container">
      {/* Header */}
      <div className="preparation-header">
        <h1>第一步: 編製時間表前的準備</h1>
        <p className="subtitle">Preparation before compiling the timetable</p>
      </div>

      {/* Introduction Section */}
      <div className="introduction-section">
        <p className="introduction-text">
          在使用校管系統編製學校時間表前，用者必須先進行一些準備工作，計劃來年的課節分配。用者必須確保以下項目已準備妥當：
        </p>
      </div>

      {/* Preparation Steps Section */}
      <div className="preparation-steps-section">
        <h2 className="preparation-steps-title">必須備妥的資料</h2>
        <ol className="preparation-steps-list">
          <li className="preparation-step">
            <div className="step-number">1</div>
            <div className="step-content">
              <p className="step-text">編定學校來年的結構</p>
            </div>
          </li>
          <li className="preparation-step">
            <div className="step-number">2</div>
            <div className="step-content">
              <p className="step-text">編定學校來年的班別資料</p>
            </div>
          </li>
          <li className="preparation-step">
            <div className="step-number">3</div>
            <div className="step-content">
              <p className="step-text">編定各班科目節數編排</p>
            </div>
          </li>
          <li className="preparation-step">
            <div className="step-number">4</div>
            <div className="step-content">
              <p className="step-text">編定來年的教師授課節數</p>
            </div>
          </li>
        </ol>
      </div>

      {/* Flowchart Section */}
      <div className="flowchart-section">
        <h2 className="flowchart-title">分班及合併情況示例 (圖二)</h2>
        <div className="flowchart-diagram">
          {/* Split Example Row */}
          <div className="flowchart-row">
            <div className="flowchart-label">英文</div>
            <div className="flowchart-boxes">
              <div className="flowchart-box">6</div>
              <div className="flowchart-box">6</div>
              <div className="flowchart-box">6</div>
            </div>
            <div className="flowchart-arrow">
              <div className="flowchart-arrow-text">分班 (split)</div>
              <div className="flowchart-arrow-icon"></div>
            </div>
          </div>

          {/* Connection Line */}
          <div className="flowchart-connection"></div>

          {/* Combine Example Row */}
          <div className="flowchart-row">
            <div className="flowchart-label">英文輔導</div>
            <div className="flowchart-boxes">
              <div className="flowchart-box">6</div>
              <div className="flowchart-box">6</div>
              <div className="flowchart-box">6</div>
            </div>
            <div className="flowchart-arrow">
              <div className="flowchart-arrow-text">合併 (combine)</div>
              <div className="flowchart-arrow-icon"></div>
            </div>
          </div>

          <div className="flowchart-figure-label">(圖二)</div>
        </div>
      </div>

      {/* Recommendation Section */}
      <div className="recommendation-section">
        <h3 className="recommendation-title">建議工作</h3>
        <p className="recommendation-text">
          預備了這些資料後，建議用者以表列方式列出各課節的分班（split）及合併（combine）情況（見圖二）。
          這將方便用者稍後輸入課節的分拆及合併資料。
        </p>
      </div>

      {/* Action Buttons */}
      <div className="action-buttons">
        <button className="action-button secondary">
          <Home size={16} />
          Exit
        </button>
        <button 
          onClick={() => onNext('planner')}
          className="action-button primary">
          <ArrowRight size={16} />
          下一步：策劃 (Next: Planner)
        </button>
      </div>
    </div>
  );
};

export default Preparation;
